import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { WorkspacePermissions } from '../../../shared/gql/generated/WorkspacePermissions';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type WorkspaceHeaderDetailsFragment = { __typename?: 'Workspace', id: string, isWorkfront?: boolean | null, name: string, visibleActiveProjectCount?: number | null, visibleInactiveProjectCount?: number | null, externallyManagedIntegration?: { __typename?: 'ExternallyManagedIntegration', integration?: Types.Integration | null, canUpdateInternalAssetContentSecurity: boolean, canUpdateWorkspaceName: boolean } | null, images?: { __typename?: 'Images', image128?: string | null, original?: string | null } | null, permissions?: { __typename?: 'WorkspacePermissions', canCreateProject: boolean, canDelete: boolean, canEditUserPermissions: boolean, canManageResourceControlPolicies: boolean, canUpdate: boolean } | null };

export const WorkspaceHeaderDetails = /*#__PURE__*/ gql`
    fragment WorkspaceHeaderDetails on Workspace {
  externallyManagedIntegration @client {
    integration
    canUpdateInternalAssetContentSecurity
    canUpdateWorkspaceName
  }
  id
  images {
    image128
    original
  }
  isWorkfront
  name
  visibleActiveProjectCount: projectCount(filter: {status: ACTIVE})
  visibleInactiveProjectCount: projectCount(filter: {status: INACTIVE})
  ...WorkspacePermissions
}
    ${WorkspacePermissions}` as unknown as DocumentNode<WorkspaceHeaderDetailsFragment, unknown>;

        

        
export const useWorkspaceHeaderDetailsFragment = (
  input: string | Omit<UseFragmentOptions<WorkspaceHeaderDetailsFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Workspace' } };
    return input;
  })();

  return useFragment<WorkspaceHeaderDetailsFragment>({
    fragment: WorkspaceHeaderDetails,
    fragmentName: 'WorkspaceHeaderDetails',
    ...options,
  });
};
  
        